import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-600">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-xs text-foreground-400" aria-hidden="true"></i>
          )}
          {item.href && index < items.length - 1 ? (
            <Link
              to={item.href}
              className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className={index === items.length - 1 ? 'text-foreground-900 font-medium whitespace-nowrap' : 'whitespace-nowrap'}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}